import { toCachedQuery } from './cacheOperations';
import { createApiConfigQueryHashMap, getQueryHashKey } from '../../apis-infra';
export function getQueryFilter() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  switch (true) {
    case args[0] == null:
      return () => true;
    case typeof args[0] === 'string':
      return _getQueryFilterByFilters({
        tags: args
      });
    case args.length > 1:
      const [apiConfig, method0, ...methods] = args;
      return _getConfigQueryFilter(apiConfig, method0, ...methods);
    default:
      // case args.length === 1 && typeof args[0] === 'object':
      return _getQueryFilterByFilters(args[0]);
  }
}
function _getQueryFilterByFilters(filters) {
  if (!filters) {
    return () => true;
  }
  const {
    pred,
    groupId,
    tags,
    serviceName,
    methodName,
    isError,
    isFetching,
    match
  } = filters;
  if (pred == null && groupId == null && tags == null) {
    return () => true;
  }
  const every = match === 'every';
  return query => {
    var _cachedQuery$tags;
    const cachedQuery = toCachedQuery(query);
    const predPassed = pred == null ? every : pred(cachedQuery);
    const fetchingPassed = isFetching == null ? every : query.isFetching() === isFetching;
    const errorPassed = isError == null ? every : !!cachedQuery.error === isError;
    const methodNamePassed = !(methodName != null && methodName.length) ? every : cachedQuery.methodName === methodName;
    const serviceNamePassed = !(serviceName != null && serviceName.length) ? every : cachedQuery.serviceName === serviceName;
    const groupIdPassed = groupId == null ? every : cachedQuery.groupId === groupId;
    const tagsPassed = tags == null ? every : !!((_cachedQuery$tags = cachedQuery.tags) != null && _cachedQuery$tags.some(tag => tags.includes(tag)));
    return match === 'every' ? predPassed && groupIdPassed && tagsPassed && methodNamePassed && serviceNamePassed && fetchingPassed && errorPassed : predPassed || groupIdPassed || tagsPassed || methodNamePassed || serviceNamePassed || fetchingPassed || errorPassed;
  };
}
function _getConfigQueryFilter(apiConfig) {
  for (var _len2 = arguments.length, methods = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    methods[_key2 - 1] = arguments[_key2];
  }
  const queryKeysMap = createApiConfigQueryHashMap(apiConfig, ...methods);
  return query => {
    const hashKey = getQueryHashKey(query.queryKey);
    return !!queryKeysMap[hashKey];
  };
}
//# sourceMappingURL=queryFilters.js.map